/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAuNjI5ODgzIDEuODU5OTlIMTUuMzc5OVYyLjg1OTk5SDAuNjI5ODgzVjEuODU5OTlaTTMuOTY5ODggNy40OTk5OUgxMi4wMTk5VjguNDk5OTlIMy45Njk4OFY3LjQ5OTk5Wk05LjkwOTg4IDEzLjE0SDYuMDg5ODhWMTQuMTRIOS45MDk4OFYxMy4xNFoiIGZpbGw9IiM3RjdGN0YiLz48L3N2Zz4=";